var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatUnderlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.916016 11.25V10.0833H9.08268V11.25H0.916016ZM4.99935 8.91667C4.0174 8.91667 3.25421 8.61042 2.70977 7.99792C2.16532 7.38542 1.8931 6.57361 1.8931 5.5625V0.75H3.39518V5.65C3.39518 6.19444 3.53129 6.63681 3.80352 6.97708C4.07574 7.31736 4.47435 7.4875 4.99935 7.4875C5.52435 7.4875 5.92296 7.31736 6.19518 6.97708C6.4674 6.63681 6.60352 6.19444 6.60352 5.65V0.75H8.1056V5.5625C8.1056 6.57361 7.83338 7.38542 7.28893 7.99792C6.74449 8.61042 5.98129 8.91667 4.99935 8.91667Z",
    fill: "#000A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatUnderlined);
export default __webpack_public_path__ + "static/media/format_underlined.512f88e7.svg";
export { ForwardRef as ReactComponent };